// extracted by mini-css-extract-plugin
export default {"Timeline":"Timeline-module--Timeline--kx0p7","Timeline__item":"Timeline-module--Timeline__item--Af05e"};